import {Component, OnDestroy} from '@angular/core';
import {ToasterService} from 'angular2-toaster';
import {ConnectionService} from './shared-component/service/connection/connection.service';
import {Spinkit} from 'ng-http-loader';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnDestroy {

  title = 'app';
  public spinkit = Spinkit;
  private connected = true;

  constructor(
    public connection: ConnectionService,
    public toasterService: ToasterService
  ) {
    this.connection.monitor(isConnected => {
      if (isConnected) {
        this.connected = true;
      } else {
        if (this.connected) {
          this.toasterService.pop('error', '', 'No internet connection');
        }
        this.connected = false;
      }
    });
  }

  ngOnDestroy() {
    this.connection.close();
  }

}


